'use client';

/* eslint-disable react/prop-types */
import React from 'react';
import { twMerge } from 'utilities/src/twMerge';
import noop from 'lodash/noop';

import { ThemeEnum } from '../Theme';

import IconComponent from '../Icon';
import useButtonTheme from './shared/themes';
import { IButtonProps } from './_props';

function Button<Theme extends ThemeEnum = ThemeEnum.Blog>({
  children,
  onClick = noop,
  size = 'Large',
  icon,
  iconName,
  iconSize,
  iconPosition = 'right',
  disabled = false,
  variant = 'Primary',
  type = 'button',
  classes = '',
  ariaLabel,
  tabIndex,
  bg,
  variantColor,
  customRef,
}: IButtonProps<Theme>) {
  const {
    buttonCommonClasses,
    buttonThemeClasses,
    buttonThemeVariantClasses,
    buttonThemeSizeClasses,
    buttonThemeTextClasses,
    buttonThemeIconClasses,
    buttonThemeOnlyIconSizeClasses,
  } = useButtonTheme({ bg, size, variant, variantColor });

  return (
    <button
      onClick={onClick}
      ref={customRef}
      // eslint-disable-next-line react/button-has-type
      type={type}
      aria-label={ariaLabel}
      key=""
      disabled={disabled}
      tabIndex={tabIndex}
      className={twMerge(
        buttonCommonClasses,
        buttonThemeClasses,
        buttonThemeVariantClasses,
        !children && !!icon ? buttonThemeOnlyIconSizeClasses : buttonThemeSizeClasses,
        {
          'flex-row-reverse': iconPosition === 'left',
          [classes]: !!classes,
        },
      )}
    >
      {children && <span className={buttonThemeTextClasses}>{children}</span>}

      <IconComponent
        Icon={icon}
        iconName={iconName}
        size={iconSize}
        options={{
          className: twMerge('transition-colors duration-300', buttonThemeIconClasses),
        }}
        className={twMerge('transition-colors duration-300', buttonThemeIconClasses)}
      />
    </button>
  );
}

export default Button;

export type { IButtonProps };
